import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { MediaBreakPointUp, Colors } from '@lean-body/components/styles';
import { ActivityCalendarPaginateButton, ActivityStreakFreezeStockCard } from '@lean-body/components/atoms';
import { ActivityCalendarDate } from '@lean-body/components/molecules/activity_calendar_date';
import { ActivityStreakMonthStat } from '@lean-body/components/molecules';
import { isToday, getLastDayOfMonth } from '@lean-body/src/util';
import { ActivityCalendarDate as ActivityCalendarDateModel } from '@lean-body/src/domain/activity_calendar_date';
import { StreakFreezeStockDialog } from '../molecules/streak_freeze_stock_dialog';
export const ActivityCalendarBlock = ({ classObject, streak, year, month, onClickNext, onClickPrev, onClickDate, totalCompletedDays, totalFreezeUsedDays, }) => {
    const [isOpenFreezeStockModal, setIsOpenFreezeStockModal] = React.useState(false);
    const lastDate = getLastDayOfMonth(year, month);
    const calenderDates = ActivityCalendarDateModel.createList(lastDate, streak.streakDates, streak.freezeUsedDates);
    const blankCount = new Date(year, month - 1, 1).getDay();
    const blankPercentage = (100 / 7) * blankCount;
    const stylesForBlank = StyleSheet.create({
        blank: {
            flex: `0 0 ${blankPercentage}%`,
        },
    });
    const onClickFreezeStock = () => {
        setIsOpenFreezeStockModal(!isOpenFreezeStockModal);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: css(styles.calendarSection, classObject) },
            React.createElement("div", { className: css(styles.header) },
                React.createElement("span", { className: css(styles.headerNumberText) }, year),
                "\u5E74",
                React.createElement("span", { className: css(styles.headerNumberText) }, month),
                "\u6708"),
            React.createElement("div", { className: css(styles.innerContainer), "data-test": "calender" },
                React.createElement(ActivityCalendarPaginateButton, { isNext: false, onClick: onClickPrev }),
                React.createElement(ActivityCalendarPaginateButton, { isNext: true, onClick: onClickNext }),
                React.createElement("ul", { className: css(styles.weeks) },
                    React.createElement("li", { className: css(styles.caption, styles.captionSunday) }, "S"),
                    React.createElement("li", { className: css(styles.caption) }, "M"),
                    React.createElement("li", { className: css(styles.caption) }, "T"),
                    React.createElement("li", { className: css(styles.caption) }, "W"),
                    React.createElement("li", { className: css(styles.caption) }, "T"),
                    React.createElement("li", { className: css(styles.caption) }, "F"),
                    React.createElement("li", { className: css(styles.caption, styles.captionSaturday) }, "S")),
                React.createElement("div", { className: css(styles.bodyContainer) },
                    React.createElement("div", { className: css(stylesForBlank.blank) }),
                    calenderDates.map((calendarDate, i) => {
                        var _a, _b;
                        const prevCalendarDate = calenderDates[i - 1];
                        const nextCalendarDate = calenderDates[i + 1];
                        return (React.createElement(ActivityCalendarDate, { key: i, number: calendarDate.date, isChecked: calendarDate.isChecked, isPrevChecked: (_a = prevCalendarDate === null || prevCalendarDate === void 0 ? void 0 : prevCalendarDate.isChecked) !== null && _a !== void 0 ? _a : false, isNextChecked: (_b = nextCalendarDate === null || nextCalendarDate === void 0 ? void 0 : nextCalendarDate.isChecked) !== null && _b !== void 0 ? _b : false, isToday: isToday(year, month, calendarDate.date), freezeUsed: calendarDate.freezeUsed, onClick: onClickDate }));
                    }))),
            React.createElement(ActivityStreakMonthStat, { classObject: styles.monthStat, totalCompletedDays: totalCompletedDays, totalFreezeUsedDays: totalFreezeUsedDays })),
        React.createElement(ActivityStreakFreezeStockCard, { freezeStock: streak.freezeStock, onClick: onClickFreezeStock }),
        isOpenFreezeStockModal && React.createElement(StreakFreezeStockDialog, { onClickCancel: onClickFreezeStock })));
};
const styles = StyleSheet.create({
    calendarSection: {
        display: 'inline-block',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% auto',
        backgroundColor: Colors.OrangeLight,
        width: '100%',
        padding: '20px 4px 20px',
    },
    calendarSection1: {
        backgroundColor: '#C6E2E4',
        backgroundImage: 'url("../assets/images/activity/activity_bg_1.svg")',
    },
    calendarSection2: {
        backgroundColor: '#EDBAC9',
        backgroundImage: 'url("../assets/images/activity/activity_bg_2.png")',
    },
    calendarSection3: {
        backgroundColor: '#fee396',
        backgroundImage: 'url("../assets/images/activity/activity_bg_3.png")',
    },
    calendarSection4: {
        backgroundColor: '#fed1d0',
        backgroundImage: 'url("../assets/images/activity/activity_bg_4.png")',
    },
    calendarSection5: {
        backgroundColor: '#d2eeba',
        backgroundImage: 'url("../assets/images/activity/activity_bg_5.png")',
    },
    calendarSection6: {
        backgroundColor: '#e1cfee',
        backgroundImage: 'url("../assets/images/activity/activity_bg_6.png")',
    },
    calendarSection7: {
        backgroundColor: '#f1daa6',
        backgroundImage: 'url("../assets/images/activity/activity_bg_7.png")',
    },
    calendarSection8: {
        backgroundColor: '#b5dfeb',
        backgroundImage: 'url("../assets/images/activity/activity_bg_8.png")',
    },
    calendarSection9: {
        backgroundColor: '#dfe4b2',
        backgroundImage: 'url("../assets/images/activity/activity_bg_9.png")',
    },
    calendarSection10: {
        backgroundColor: '#fdc699',
        backgroundImage: 'url("../assets/images/activity/activity_bg_10.png")',
    },
    calendarSection11: {
        backgroundColor: '#ddc7b5',
        backgroundImage: 'url("../assets/images/activity/activity_bg_11.png")',
    },
    calendarSection12: {
        backgroundColor: '#766964',
        backgroundImage: 'url("../assets/images/activity/activity_bg_12.png")',
    },
    header: {
        color: Colors.TextDark,
        display: 'flex',
        justifyContent: 'center',
        fontSize: 10,
        fontWeight: 700,
        lineHeight: '140%',
        letterSpacing: 0.3,
        gap: 2,
    },
    headerImg: {
        height: 38,
        [MediaBreakPointUp.SM]: {
            height: 65,
        },
    },
    headerNumberText: {
        fontFamily: 'Gotham SSm A, Gotham SSm B',
        fontSize: 16,
    },
    innerContainer: {
        backgroundColor: Colors.White,
        borderRadius: 8,
        boxShadow: '0 2px 10px 0 rgba(0,0,0,0.05)',
        margin: '10px auto',
        position: 'relative',
        width: '90%',
        padding: 18,
        [MediaBreakPointUp.XL]: {
            maxWidth: 500,
        },
    },
    bodyContainer: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    monthStat: {
        width: '90%',
        margin: '0 auto',
        [MediaBreakPointUp.XL]: {
            maxWidth: 500,
        },
    },
    weeks: {
        display: 'flex',
        justifyContent: 'center',
        marginBottom: 8,
    },
    caption: {
        color: Colors.Gray,
        flex: '0 0 14.281%',
        fontWeight: 500,
        textAlign: 'center',
    },
    captionSaturday: {
        color: '#23C0F1',
    },
    captionSunday: {
        color: '#FF1F00',
    },
});
